export const state = {
  // product: undefined,
  // products: []
  attribut: {},
  attributs: [],
  pagination: {
    size: 10,
  },
};
